import React, { Component } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services';
import { Select } from 'antd';
import $ from 'jquery';
import { toast } from "react-toastify";  
  const { Option } = Select

  var optionsEntidade = [];
  var optionsEntidadeData = [];
  var entidadeSelected = null;
  var DropDownCellTipoVasilha = null;
  var thisMySelect = null;
  var opcoes;
  var optionsEntidade2 = [];
  function myFunction(selection) {
    optionsEntidade = [];
    optionsEntidade2 = [];
    (async (e) => {

      entidadeSelected = selection != null ? selection : $('#id-select-Entidade [name="form-field-name"]').val();

      const data = {"IDEntidade": entidadeSelected}
      const EtiquetasSeguranca = await services.apiCall.requestApi(
          "/Fiscalizacao/GetEtiquetasSegurancaEntidade",
          data,
          "get"
      );

      console.log('EtiquetasSeguranca');

      if(EtiquetasSeguranca){
        EtiquetasSeguranca.map((Etiqueta, index) => (
          optionsEntidade.push(<Option key={index} value={Etiqueta.idSelosSeguranca}>{Etiqueta.numeroSelo}</Option>)
        ));
      }

      const data2 = {"IDEntidade": entidadeSelected}
      const EtiquetasSeguranca2 = await services.apiCall.requestApi(
          "/Fiscalizacao/GetAllEtiquetasSegurancaEntidade",
          data,
          "get"
      );

      console.log('EtiquetasSeguranca');

      if(EtiquetasSeguranca2){
        EtiquetasSeguranca2.map((Etiqueta, index) => (
          optionsEntidade2.push(<Option key={index} value={Etiqueta.idSelosSeguranca}>{Etiqueta.numeroSelo}</Option>)
        ));
      }
    })();
  };



class SelectCellEtiquetas extends React.Component {
  
  static changeValueFromSelect = (e) => {

    myFunction(e);

  }

  handleChangeCertProcSelosSeg = (e) => {

    var dataItemArray = [];
    var dataItemArrayField = [];

    for(let i = 0; i < e.length; i++){
      if(optionsEntidade.find(c=> c.props.value == e[i]) == undefined){
        dataItemArray.push(optionsEntidade2.find(c=> c.props.value == e[i]).props)
      }else{
        dataItemArray.push(optionsEntidade.find(c=> c.props.value == e[i]).props)
      }
      
    }
    if(this.props.field == "EtiquetasSegurancaIVDP"){
      if(dataItemArray.length > parseInt($(".NGarrafasIVDP").val())){
        toast.error("O número de etiquetas não pode exceder o número de garrafas.");
        return;
      }
    }

    if(this.props.field == "EtiquetasSegurancaAE"){
      if(dataItemArray.length > parseInt($(".NGarrafasAE").val())){
        toast.error("O número de etiquetas não pode exceder o número de garrafas.");
        return;
      }
    }
    if(this.props.field == "Etiquetas_segurança_IDVP"){
      if(dataItemArray.length > parseInt($(".NGarrafasIVDP").val())){
        toast.error("O número de etiquetas não pode exceder o número de garrafas.");
        return;
      }
    }

    if(this.props.field == "Etiquetas_segurança_AE"){
      if(dataItemArray.length > parseInt($(".NGarrafasAE").val())){
        toast.error("O número de etiquetas não pode exceder o número de garrafas.");
        return;
      }
    }
    optionsEntidadeData[this.props.field] = (dataItemArray.length > 0 ? dataItemArray : []);

    this.props.onChange({
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e != null ? e.syntheticEvent : null,
      value: e.length > 0 ? e : null
    });

  }

  render() {

    thisMySelect = this;

    const {
      dataItem
    } = this.props;
    const field = this.props.field || '';
    var dataValue = dataItem[field] === null ? '' : dataItem[field];
    // if(field == "Etiquetas_segurança_AE"){
    //   dataItem[field] = optionsEntidadeData[field]
    //   dataValue = dataItem.Etiquetas_segurança_AE.map((value) => (
    //     value.value
    //   ))
    // }
    // if(field == "Etiquetas_segurança_IDVP"){
    //   dataItem[field] = optionsEntidadeData[field]
    //   dataValue = dataItem.Etiquetas_segurança_IDVP.map((value) => (
    //     value.value
    //   ))
    // }
        

    var StringArray = "";

    return (
        <td>
            {this.props.dataItem.inEdit ?
            
            <Select
                mode="multiple"
                allowClear
                optionFilterProp="children"
                placeholder="Selecione as Etiquetas de segurança"
                value={dataValue != null && dataValue != "" ? dataValue.map((value) => (
                  optionsEntidade.find(c=> c.props.value == value) == undefined ?
                  optionsEntidade2.find(c=> c.props.value == value).props.value :
                  optionsEntidade.find(c=> c.props.value == value).props.value
                )) : undefined}
                onChange={this.handleChangeCertProcSelosSeg}
                style={{ width: "100%" }}>
                {
                  optionsEntidade
                }
            </Select>

            : dataValue != null  &&  dataValue != "" ?  dataValue.map((value,index) => (
              opcoes = optionsEntidade.find(c=> c.props.value == value) == undefined ? 
              opcoes = optionsEntidade2.find(c=> c.props.value == value) == undefined? undefined :
              <span key={index} className="ant-select-selection-item-content-etiquetas">{optionsEntidade2.find(c=> c.props.value == value).props.children}</span> : 
              <span key={index} className="ant-select-selection-item-content-etiquetas">{optionsEntidade.find(c=> c.props.value == value).props.children}</span>
              )) : undefined}

        </td>
  )};
    
}
export default SelectCellEtiquetas;